/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  OrganizationUser,
  OrganizationUser$inboundSchema,
} from "./organizationuser.js";

export type ListUsersResult = {
  /**
   * Users linked to the organization in Speakeasy.
   */
  users: Array<OrganizationUser>;
};

/** @internal */
export const ListUsersResult$inboundSchema: z.ZodMiniType<
  ListUsersResult,
  unknown
> = z.object({
  users: z.array(OrganizationUser$inboundSchema),
});

export function listUsersResultFromJSON(
  jsonString: string,
): SafeParseResult<ListUsersResult, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ListUsersResult$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ListUsersResult' from JSON`,
  );
}
